export type SyncRunStatus = "RUNNING" | "COMPLETED" | "FAILED" | "CANCELLED";

export type SyncType = string;

export type SyncDetailsJson = Record<string, unknown> | string | null;

/**
 * TAS-516 — the sync type the "Sync Service Orders" button produces a run of. Matched
 * case-insensitively against `ClientSyncRun.syncType` to tell whether a run is already
 * in flight, so the button cannot start a second one on top of it.
 */
export const SERVICE_ORDER_SYNC_TYPE = "SERVICEORDERS";

/** TAS-516 — one Vista SM company's slice of a service-order sync run. */
export interface ServiceOrderSyncCompanyDetail {
  rowsRead: number;
  inserted: number;
  updated: number;
  unchanged: number;
  deactivated: number;
  /** Service orders Vista returned again, flipped back to active. Also counted in `updated`. */
  reactivated: number;
  scopesRead: number;
  scopesInserted: number;
  scopesUpdated: number;
  scopesUnchanged: number;
  scopesDeactivated: number;
  projectResolved: number;
  projectUnresolved: number;
  errors: string[];
}

/** TAS-516 — the sync app's counts: the two companies plus their totals, flattened. */
export interface ServiceOrderSyncDetails extends ServiceOrderSyncCompanyDetail {
  company2: ServiceOrderSyncCompanyDetail;
  company3: ServiceOrderSyncCompanyDetail;
}

/**
 * TAS-516 — what `POST /admin/sync/serviceOrders` answers.
 *
 * A sync FAILURE comes back 200 with `success: false` and a message, exactly like
 * `/admin/sync/employeeUpdate`: the client is plain axios, which throws on a non-2xx and
 * discards the body, so a 500 would hide the reason from the popup. The one genuine
 * non-2xx is the 404 every non-NPM tenant gets.
 */
export interface ServiceOrderSyncResult {
  success: boolean;
  message?: string;
  errorMessage?: string;
  /** The ClientSyncRun this button created, so the run can be found on this page. */
  clientSyncRunID?: number;
  details?: ServiceOrderSyncDetails | null;
}

export interface ClientSyncRun {
  clientSyncRunID: number;
  syncType: SyncType;
  status: SyncRunStatus;
  startedAtUtc: string;
  completedAtUtc: string | null;
  durationSeconds: number | null;
  errorMessage: string | null;
  errorDetailsJson: SyncDetailsJson;
  successDetailsJson: SyncDetailsJson;
  triggeredBy: string;
  createdAtUtc: string;
  updatedAtUtc: string;
}
